import React from 'react';

import { t } from 'i18n/index';

// Rendered by the top-level Sentry.ErrorBoundary after an uncaught render
// error. Kept dependency-free (no app CSS, no MUI) so it cannot be taken down
// by whatever crashed the tree — e.g. a Google-Translate-mangled DOM.
const AppCrashFallback = () => (
  <div
    role="alert"
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '24px',
      textAlign: 'center',
      fontFamily: 'sans-serif',
      gap: '16px',
    }}
  >
    <p>{t('errors:appCrashed')}</p>
    <button
      onClick={() => window.location.reload()}
      style={{
        padding: '12px 24px',
        fontSize: '16px',
        cursor: 'pointer',
      }}
    >
      {t('errors:appCrashedReload')}
    </button>
  </div>
);

export default AppCrashFallback;
